// 轉大寫指令 
export const uppercase = {
    /**
     * 初始設定 vue3: bind => beforeMount
     * @param {*} el - 元素
     * @param {Object} binding - 綁定的物件
     */
    beforeMount: function(el, binding) {
        if(binding.value === true ){
            /** 離開焦點事件 */
            el.addEventListener('blur', handleEvent);
            /** 放開鍵盤事件 */
            el.addEventListener('keyup', function(e){
                /** 針對enter鍵 */
                if(e.key === 'Enter' || e.keyCode === 13){
                    handleEvent(e);
                }
            });
        }

        /**
         * 將元素中的值轉大寫並觸發input事件
         * @param {*} e - event
         */
        function handleEvent(e){
            if(e && e.isComposing) return;
            if(el.value) el.value = el.value.toUpperCase();
            el.dispatchEvent(new Event('input'));
        }
    }
};

// 刪除前後空白指令 
export const trim = {
    /**
     * 初始設定 vue3: bind => beforeMount
     * @param {*} el - 元素
     * @param {Object} binding - 綁定的物件
     */
    beforeMount: function(el, binding) {
        if(binding.value === true ){
            /** 離開焦點事件 */
            el.addEventListener('blur', handleEvent);
            /** 放開鍵盤事件 */
            el.addEventListener('keyup', function(e){
                /** 針對enter鍵 */
                if(e.key === 'Enter' || e.keyCode === 13){
                    handleEvent(e);
                }
            });
        }

        /**
         * 將元素中的值刪除前後空白並觸發input事件
         * @param {*} e - event
         */
        function handleEvent(e){
            if(e && e.isComposing) return;
            if(el.value) el.value = el.value.trim();
            el.dispatchEvent(new Event('input'));
        }
    }
};

// 按在物件之外的指令
export const clickOutside = {
    /**
     * 初始設定 vue3: bind => beforeMount
     * @param {*} el - 元素
     * @param {Object} binding - 綁定的物件
     * @param {*} vnode - vue Virtual DOM
     */
    beforeMount: function (el, binding) {
        el.clickOutsideEvent = function (event) {  
            //  確認確實按到物件之外的地方
            if (!(el === event.target || el.contains(event.target))) {
            {
                // 呼叫給的指令。指令名稱存在 binding.expression
                binding.value(event, el); 
            }
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    /**
     * 解除設定 vue3: unbind => unmounted
     * @param {*} el - 元素
     */
    unmounted(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
};